import "./App.css";
import "./Utilities/sweetAlert.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-image-gallery/styles/css/image-gallery.css";

import UserRoutes from "./Resources/Pages/Routes/Routes";
import RoutePage from "./Resources/Pages/Route/Route";
import { Main, Login, Trails, Reviews, Trail, TrailReviews, UserManagement, UserDetails, LocationsManagement, Statistics, VersionManagement } from "./Resources/Pages";
import OnboardingQuestions from "./Resources/Pages/OnboardingQuestions/OnboardingQuestions";
import TagManagement from "./Resources/Pages/TagManagement/TagManagement";
import { Header, Sidebar } from "./Resources/Layout";
import { Route, Routes } from "react-router-dom";
import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import Waypoints from './Resources/Pages/Waypoints/Waypoints';
import Notifications from "./Resources/Pages/Notifications/Notifications";

function App(): JSX.Element {
  const currentUser = useSelector((state: RootState) => state.user).currentUser;

  const renderLogInRoutes = (): JSX.Element => {
    return (
      <Routes>
        <Route Component={Login} path="*" />
      </Routes>
    );
  };

  const renderLoggedInRoutes = (): JSX.Element => {
    return (
      <Routes>
        <Route Component={UserDetails} path="/users/:id" />
        <Route Component={UserManagement} path="/users" />
        <Route Component={Trails} path="/trails" />
        <Route Component={UserRoutes} path="/routes" />
        <Route Component={RoutePage} path="/route/edit/:id" />
        <Route Component={Trail} path="/trail/edit/:id" />
        <Route Component={Trail} path="/trail/new" />
        <Route Component={Waypoints} path="/waypoints/:id" />
        <Route Component={TrailReviews} path="/trail/:id/reviews" />
        <Route Component={Reviews} path="/reviews" />
        <Route Component={TagManagement} path="/tags" />
        <Route Component={LocationsManagement} path="/locations" />
        <Route Component={Notifications} path="/notifications" />
        <Route Component={Statistics} path="/statistics" />
        <Route Component={OnboardingQuestions} path="/onboarding-questions" />
        <Route Component={VersionManagement} path="/versions" />
        <Route Component={Main} path="/" />
      </Routes>
    );
  };

  return (
    <div className="admin-layout">
      {_.isEmpty(currentUser) ? (
        <div className="login-layout">
          {renderLogInRoutes()}
        </div>
      ) : (
        <>
          <Sidebar />
          <Header />
          <div className="admin-content">
            {renderLoggedInRoutes()}
          </div>
        </>
      )}
    </div>
  );
}

export default App;
